import Vue from 'vue'

const luRole = {
  state: {
    luRoles: [],
    selectedLuRole: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luRoles(state) {
      return state.luRoles
    },
    selectedLuRole(state) {
      return state.selectedLuRole
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luRoles(state, payload) {
      state.luRoles = payload
    },
    selectedLuRole(state, payload) {
      state.selectedLuRole = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuRole(context, payload) {
      context.commit('selectedLuRole', payload)
    },
    loadLuRoles(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuRole'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('luRoles', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedLuRole(context, payload) {
      if (context.state.selectedLuRole && context.state.selectedLuRole.ID) {
        context.dispatch('loadSelectedLuRole', context.state.selectedLuRole.ID)
      }
    },
    loadSelectedLuRole(context, payload) {
      if (
        context.state.selectedLuRole &&
        context.state.selectedLuRole.ID != payload
      ) {
        context.commit('selectedLuRole', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'LuRole/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedLuRole', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadLuRoles(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadLuRoles')
      })
    },
    updateLuRole(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuRole/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'role updated' },
              { root: true }
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuRoles')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createLuRole(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuRole`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'role created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuRoles')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    saveLuRole(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLuRole', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createLuRole', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteLuRole(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuRole/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'role deleted' },
              { root: true }
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuRoles')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default luRole
